import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'displayTrainTypeName'
})
export class DisplayTrainTypeNamePipe implements PipeTransform {

  transform(trainTypeObjects: any, customTrainTypeNames: {
    code: string,
    displayName: string
  }[]): string {
    return trainTypeObjects.map(trainTypeObject => {
      const customTrainType = customTrainTypeNames && customTrainTypeNames[trainTypeObject.trainType];
      const displayName =  customTrainType ? customTrainType.displayName : trainTypeObject.trainType;
      return {
        ...trainTypeObject,
        displayName
      }
    })
  }

}
